import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import { DisplayValue } from '../Shared/Scripts/Models/Valg';
import SelectOptionStegDisplay from '../Shared/Scripts/Components/SelectOptionStegComponent';
import SkolePengerInputSteg from '../Shared/Scripts/Components/SkolePengerSteg';
import VelgUniversitetComponentVisning from '../Shared/Scripts/Components/VelgUniversitetComponent';
import LandOgUniversitetModel from '../Shared/Scripts/Models/LandOgUniversitetModel';

import VeilederUtlandDto from './Models/VeilederUtlandDto';
import { StamdataUtlandHelgradModel } from './Models/StamdataUtlandHelgradModel';
import { VeilederUtlandAppState } from './Store';
import * as ValgTypes from './Store/Valg/Types';
import { ResultatValg } from './Store/Resultat/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import * as Ids from './Models/Ids';
import UtdanningValg from './Utilities/UtdanningTypeValg';
import VerdensdelValg from './Utilities/VerdensdelValg';
import { VelgAntallArComponentVisning } from './Components/VelgAntallAr';

import { OppsummeringLanOgStipendComponent } from './Components/OppsummeringLanOgStipendSteg';
import * as UtregningUtland from './Utilities/Utregning';
import UtregningA from './Components/UtregningA';
import UtregningB from './Components/UtregningB';
import UtbetalingComponent from './Components/UtbetalingComponent';
import SiteImproveHandler, {
    SiteImproveState,
    SiteImproveEvents,
    SiteImproveKategorier,
} from '../Shared/Scripts/Utilities/SiteImproveEventsHandler';

interface AppOwnProps {}

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederUtlandDto>();

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

interface AppState {}

class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const { valg, dispatchUpdateValg, epiContext, satser, resultat, universiteter } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;

        function registerSiteImproveEvents(): void {
            if (!SiteImproveState.Startet) {
                if (valg.aUtdanning != undefined) {
                    //veileder påstartet
                    SiteImproveState.Startet = true;
                    SiteImproveHandler.registerSiteImproveEvent(
                        SiteImproveKategorier.Veileder,
                        SiteImproveEvents.VeilederStart,
                        SiteImproveHandler.hentOverskrift(),
                    );
                }
            }

            if (!SiteImproveState.Fullfort) {
                if (resultat.visBoksFa || resultat.visBoksFb) {
                    //veileder fullført
                    SiteImproveState.Fullfort = true;
                    SiteImproveHandler.registerSiteImproveEvent(
                        SiteImproveKategorier.Veileder,
                        SiteImproveEvents.VeilederFullfort,
                        SiteImproveHandler.hentOverskrift(),
                    );
                }
            }

            if (!SiteImproveState.Fullfort_del2) {
                if (resultat.visBoksH) {
                    //veileder fullført
                    SiteImproveState.Fullfort = true;
                    SiteImproveHandler.registerSiteImproveEvent(
                        SiteImproveKategorier.Veileder,
                        SiteImproveEvents.VeilederFullfort_del2,
                        SiteImproveHandler.hentOverskrift(),
                    );
                }
            }
        }

        function getLand(): DisplayValue[] {
            const items: DisplayValue[] = [];

            if (universiteter == null || universiteter == undefined || universiteter.length <= 0) return [];

            let annetLand: LandOgUniversitetModel | null = null;

            for (let i = 0; i < universiteter.length; i++) {
                if (universiteter[i].Kode === valg.bVerdensdel?.id) {
                    let erAlleredeLagtTilILandListen: boolean = false;
                    for (let x = 0; x < items.length; x++) {
                        if (items[x].id == universiteter[i].Landkode) erAlleredeLagtTilILandListen = true;
                    }

                    if (erAlleredeLagtTilILandListen) continue;

                    if (universiteter[i].Landkode === 'E') {
                        annetLand = universiteter[i];
                        continue;
                    }

                    if (locale === 'en-US') {
                        items.push({
                            id: universiteter[i].Landkode,
                            displayValue: universiteter[i].EngelskLandNavn,
                        });
                    } else {
                        items.push({
                            id: universiteter[i].Landkode,
                            displayValue: universiteter[i].LandNavn,
                        });
                    }
                }
            }

            let sorted: DisplayValue[] = items.sort(function (a, b) {
                var nameA = a.displayValue.toUpperCase();
                var nameB = b.displayValue.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            if (annetLand !== null) {
                if (locale === 'en-US') {
                    sorted.push({
                        id: annetLand.Landkode,
                        displayValue: annetLand.EngelskLandNavn,
                    });
                } else {
                    sorted.push({
                        id: annetLand.Landkode,
                        displayValue: annetLand.LandNavn,
                    });
                }
            }

            return sorted;
        }

        function hentUniversiteterBasertPaLandValg() {
            let items: DisplayValue[] = [];

            if (valg.cLand?.id === 'E') {
                return items;
            }

            if (universiteter !== null) {
                for (let i = 0; i < universiteter.length; i++) {
                    if (universiteter[i].Landkode === valg.cLand?.id) {
                        items.push({ id: universiteter[i].Universitet, displayValue: universiteter[i].Universitet });
                    }
                }
            }
            return items;
        }

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            registerSiteImproveEvents()
            return (
                <div>
                    <div className="c-veileder">
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksA}
                            tittel={contentResolver(epiContext, 'tittelUtdanning')}
                            forklaring={contentResolver(epiContext, 'infoUtdanning')}
                            sporsmal="ledetekstUtdanning"
                            valg={UtdanningValg.utdanningValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ aUtdanning: nyttValg, visUtbetalingsplan: false });
                            }}
                            neverCollapse={true}
                            classModifier="c-veileder__panel--input-white"
                            value={valg.aUtdanning}
                        />
                        {resultat.visBoksB && (
                            <RadioButtonsStegComponent
                                sporsmalId={Ids.BoksB}
                                tittel={contentResolver(epiContext, 'tittelVerdensdel')}
                                forklaring={
                                    <div>
                                        <p>{contentResolver(epiContext, 'infoVerdensdel')}</p>
                                    </div>
                                }
                                sporsmal="ledetekstVerdensdel"
                                neverCollapse={false}
                                valg={VerdensdelValg.bValg}
                                onInputChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({
                                        bVerdensdel: nyttValg,
                                        cLand: undefined,
                                        dSkolepenger: undefined,
                                        eUniversitetUtvidetStipend: undefined,
                                        visUtbetalingsplan: false,
                                    });
                                }}
                                value={valg.bVerdensdel}
                            />
                        )}
                        {resultat.visBoksC && (
                            <SelectOptionStegDisplay
                                sporsmalId="land-velger-nedtrekk"
                                tittel={contentResolver(epiContext, 'tittelLand')}
                                options={getLand()}
                                forklaring={contentResolver(epiContext, 'infoLand')}
                                ledetekst={contentResolver(epiContext, 'ledetekstLand')}
                                onSelectChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({
                                        cLand: nyttValg,
                                        eUniversitetUtvidetStipend: undefined,
                                        dSkolepenger: undefined,
                                        visUtbetalingsplan: false,
                                    });
                                }}
                                value={valg.cLand}
                            />
                        )}
                        {resultat.visBoksD && (
                            <SkolePengerInputSteg
                                sporsmalId={Ids.BoksD}
                                tittel={contentResolver(epiContext, 'tittelSkolePenger')}
                                forklaring={contentResolver(epiContext, 'infoSkolePenger')}
                                ledetekst={contentResolver(epiContext, 'ledetekstSkolePenger')}
                                benevnelseForSkolepenger={contentResolver(epiContext, 'benevnelseForSkolepenger')}
                                valutaBenevnelse={valuta}
                                valgUkjentInputLedetekst={contentResolver(epiContext, 'valgSkolePengerUkjent')}
                                valgKnappTekst={contentResolver(epiContext, 'valgSkolePengerKnapp')}
                                onChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ dSkolepenger: nyttValg, visUtbetalingsplan: false });
                                }}
                                value={valg.dSkolepenger}
                                visMerOmSkolePengerLenkeTekst={contentResolver(
                                    epiContext,
                                    'merOmSkolePengerLenkeTekst',
                                )}
                                lukkSkolepengerPopupAriaTekst={resolveRawText(
                                    epiContext,
                                    'lukkSkolepengerPopupAriaTekst',
                                )}
                                tittelMerSkolePengerTekst={contentResolver(epiContext, 'tittelMerSkolePengerTekst', 2)}
                                brodtekstMerSkolePengerTekst={contentResolver(
                                    epiContext,
                                    'brodtekstMerSkolePengerTekst',
                                    2,
                                )}
                                locale={locale}
                                visBiCheckbox={false}
                                biLabel={null}
                            />
                        )}
                        {resultat.visBoksE && (
                            <VelgUniversitetComponentVisning
                                sporsmalId={'universitet-velger-nedtrekk'}
                                tittel={contentResolver(epiContext, 'tittelTilleggsstipend')}
                                forklaring={contentResolver(epiContext, 'infoTilleggsstipend')}
                                ledetekst={contentResolver(epiContext, 'ledetekstTilleggsstipend')}
                                ingenValgTekst={resolveRawText(epiContext, 'ingenUniValgtVisningTekst')}
                                options={hentUniversiteterBasertPaLandValg()}
                                avhukingBoksTekst={contentResolver(epiContext, 'avhukingTekstTilleggsstipend')}
                                onSelectChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ eUniversitetUtvidetStipend: nyttValg, visUtbetalingsplan: false });
                                }}
                                value={valg.eUniversitetUtvidetStipend}
                                showSearch={true}
                            />
                        )}
                        {resultat.visBoksFa && (
                            <UtregningA
                                tittelUtregning={contentResolver(epiContext, 'tittelUtregning')}
                                valg={valg}
                                satser={satser}
                                visUtbetalingsPlanHandler={(visPlanen: boolean): void => {
                                    dispatchUpdateValg({ visUtbetalingsplan: visPlanen });
                                }}
                                valutaBenevnelseUtregning={valuta}
                                stipendVilkarTekst={contentResolver(epiContext, 'stipendVilkarTekst')}
                                stipendTittelUtregning={contentResolver(epiContext, 'stipendTittelUtregning')}
                                lanTittelUtregning={contentResolver(epiContext, 'lanTittelUtregning')}
                                tekstForLanOgStipendSomAlleFaar={contentResolver(
                                    epiContext,
                                    'tekstForLanOgStipendSomAlleFaar',
                                )}
                                tekstForDeMedSkolepenger={contentResolver(epiContext, 'tekstForDeMedSkolepenger')}
                                tekstForDeMedSkolepengerOgTilleggsstipend={contentResolver(
                                    epiContext,
                                    'tekstForDeMedSkolepengerOgTilleggsstipend',
                                )}
                                tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan={contentResolver(
                                    epiContext,
                                    'tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan',
                                )}
                                tekstForDeMedSkolepengerOgTilleggslan={contentResolver(
                                    epiContext,
                                    'tekstForDeMedSkolepengerOgTilleggslan',
                                )}
                                resTekstAlleOgRekruttering={contentResolver(
                                    epiContext, 'resTekstAlleOgRekruttering')}
                                resTekstSkolepengerRekruttering={contentResolver(
                                    epiContext, 'resTekstSkolepengerRekruttering')}
                                resTekstSkolepengerUtvidetstipendRekruttering={contentResolver(
                                    epiContext, 'resTekstSkolepengerUtvidetstipendRekruttering')}
                                resTekstSkolepUtvidetstipendUtvidetlanRekruttering={contentResolver(
                                    epiContext, 'resTekstSkolepUtvidetstipendUtvidetlanRekruttering')}
                                resTekstSkolepengerUtvidetlanRekruttering={contentResolver(
                                    epiContext, 'resTekstSkolepengerUtvidetlanRekruttering')}
                                vilkarStudieStotteLenkeTekst={contentResolver(
                                    epiContext,
                                    'vilkarStudieStotteLenkeTekst',
                                )}
                                vilkarStudieStotteTittel={contentResolver(epiContext, 'vilkarStudieStotteTittel')}
                                vilkarStudieStotteTekst={contentResolver(epiContext, 'vilkarStudieStotteTekst')}
                                vilkarLukkStudieStottePopupAriaTekst={resolveRawText(
                                    epiContext,
                                    'vilkarLukkStudieStottePopupAriaTekst',
                                )}
                                utbetalingsPlanLenkeTekst={contentResolver(epiContext, 'utbetalingsPlanLenkeTekst')}
                                profesjonUnntakOppsummering={contentResolver(epiContext, 'profesjonUnntakOppsummering')}
                                locale={locale}
                            />
                        )}
                        {resultat.visBoksFb && (
                            <UtregningB
                                tittelUtregning={contentResolver(epiContext, 'tittelUtregning')}
                                valg={valg}
                                satser={satser}
                                visUtbetalingsPlanHandler={(visPlanen: boolean): void => {
                                    dispatchUpdateValg({ visUtbetalingsplan: visPlanen });
                                }}
                                valutaBenevnelseUtregning={valuta}
                                beskrivelseLanFb={contentResolver(epiContext, 'beskrivelseLanFb')}
                                overskriftLanFb={contentResolver(epiContext, 'overskriftLanFb')}
                                tekstForLanOgStipendSomAlleFaar={contentResolver(
                                    epiContext,
                                    'tekstForLanOgStipendSomAlleFaar',
                                )}
                                resTekstAlleOgRekruttering={contentResolver(
                                    epiContext,
                                    'resTekstAlleOgRekruttering',
                                )}
                                vilkarStudieStotteLenkeTekst={contentResolver(
                                    epiContext,
                                    'vilkarStudieStotteLenkeTekst',
                                )}
                                vilkarStudieStotteTittel={contentResolver(epiContext, 'vilkarStudieStotteTittel')}
                                vilkarStudieStotteTekst={contentResolver(epiContext, 'vilkarStudieStotteTekst')}
                                vilkarLukkStudieStottePopupAriaTekst={resolveRawText(
                                    epiContext,
                                    'vilkarLukkStudieStottePopupAriaTekst',
                                )}
                                utbetalingsPlanLenkeTekst={contentResolver(epiContext, 'utbetalingsPlanLenkeTekst')}
                                locale={locale}
                            />
                        )}
                        {resultat.visBetPlan && (
                            <UtbetalingComponent
                                valg={valg}
                                satser={satser}
                                resultat={resultat}
                                locale={locale}
                                valuta={valuta}
                            />
                        )}
                        {resultat.visBoksG && (
                            <VelgAntallArComponentVisning
                                id={Ids.BoksG}
                                tittel={contentResolver(epiContext, 'tittelHeleUtdanning')}
                                forklaring={contentResolver(epiContext, 'infoHeleUtdanning')}
                                ledetekst={contentResolver(epiContext, 'ledetekstHeleUtdanning')}
                                obsmelding={contentResolver(epiContext, 'obsMelding')}
                                startAntallAr={0}
                                onChange={(nyttValg: Valg<number>): void => {
                                    dispatchUpdateValg({ gAntallAr: nyttValg });
                                }}
                            />
                        )}
                        {resultat.visBoksH && (
                            <OppsummeringLanOgStipendComponent
                                basisLan={UtregningUtland.regnUtBasisLan(valg, satser)}
                                reiseStotte={UtregningUtland.regnUtReiseStotte(valg, satser)}
                                skolePenger={UtregningUtland.regnUtSkolepengerStotte(valg, satser)}
                                rekrutteringsstipend={UtregningUtland.regnUtRekrutteringsstipend(valg, satser)}
                                valg={valg}
                                locale={locale}
                                valuta={valuta}
                                tittelMinimumTotaltLan={contentResolver(epiContext, 'tittelMinimumTotaltLan')}
                                infoOmLan={contentResolver(epiContext, 'infoOmLan')}
                                tittelMaksimumTotaltStipend={contentResolver(epiContext, 'tittelMaksimumTotaltStipend')}
                                infoOmStipend={contentResolver(epiContext, 'infoOmStipend')}
                                lenketekstOmLanOgStipend={contentResolver(epiContext, 'lenketekstOmLanOgStipend')}
                                vilkarLukkVilkårGjeldOgBetaling={contentResolver(
                                    epiContext,
                                    'vilkarLukkVilkårGjeldOgBetaling',
                                )}
                                vilkarGjeldOgBetalingTittel={contentResolver(epiContext, 'vilkarGjeldOgBetalingTittel')}
                                vilkarGjeldOgBetalingTekst={contentResolver(epiContext, 'vilkarGjeldOgBetalingTekst')}
                            />
                        )}
                    </div>
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederUtlandDto>;
    resultat: ResultatValg;
    satser: StamdataUtlandHelgradModel | null;
    universiteter: Array<LandOgUniversitetModel> | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederUtlandAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederUtlandAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
    universiteter: state.universiteter,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
